import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { useReveals } from '@/lib/use-reveals'
import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children, transparentHeader }): ReactNode => {
    useReveals()

    return (
        <div className='flex min-h-screen flex-col overflow-x-clip bg-cream'>
            <Header transparent={transparentHeader} />

            <main className='flex-1'>
                {children}
            </main>

            <Footer />
        </div>
    )
}
